module.exports = __webpack_public_path__ + "public/img/scsjzl.ea1ca941.png";